import React from 'react';
import Lottie from 'react-lottie';
import './Alert_Lottie.css';
import * as animationData from './Alert_Lottie.json';

const Alert_Lottie = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <>
            <section className='main'>
                <div className='Alert_Lottie_icon'>
                    <Lottie className="me-auto"
                        options={defaultOptions}
                    // height={60}
                    // width={60}          
                    />
                </div>
            </section>
        </>
    )
}

export default Alert_Lottie
